module.exports = __webpack_public_path__ + "img/coming-soon-dark.456fb764.svg";